import { Avatar } from '@material-ui/core';
import './EmployeeRank.scss';
import { EmployeeRankProps } from './typing';

/**
 * @param {EmployeeRankProps} props
 * @returns
 */
export default function EmployeeRank(props) {
    const { label, rank, avatar } = props;

    /**
     * @param {number} employeeRank
     * @returns {string}
     */
    const getEmployeeRank = (employeeRank) => {
        let rankLabel = `${employeeRank}`;
        let lastDigit = employeeRank?.toString().split('').pop();

        if (employeeRank >= 11 && employeeRank <= 13) {
            lastDigit = '';
        }

        switch (lastDigit) {
            case '1':
                rankLabel += 'st';
                break;
            case '2':
                rankLabel += 'nd';
                break;
            case '3':
                rankLabel += 'rd';
                break;
            default:
                rankLabel += 'th';
                break;
        }
        return rankLabel;
    };

    return (
        <div className="avatar-container" >
            <span className="label">{label}</span>
            <span className="number">{getEmployeeRank(rank)}</span>
            <Avatar className="avatar">{avatar}</Avatar>
        </div>
    );
}
